export enum TipoRecorrencia {
    Diaria = 1,
    Semanal = 2,
    Mensal = 3,
    Ano = 4
  }